import { useContext } from 'react';
import { Box, Tooltip, useTheme } from '@mui/material';
import SvgEyeIcon from '../../../images/icons/eye_icon.svg?react';
import { DocumentDispatchContext } from '../../../context/DocumentContext';
import { IDocument } from '../../../types/my-types';
import TableStyles from '../../documents/Table.module.css';
import DrawIcon from '@mui/icons-material/Draw';
import { AppContext } from '../../../App';
import { Link } from 'react-router';
import DownloadDocument from '../../common/DownloadDocument';
import TrainingSetDeleteDocument from '../actions/TrainingSetDeleteDocument';
import { ITrainingSet } from '../../../types/my-types';

export interface ITrainingSetDocumentActionsProps {
  document: IDocument;
  trainingSet: ITrainingSet;
}
const TrainingSetDocumentActions = ({
  document,
  trainingSet,
}: ITrainingSetDocumentActionsProps) => {
  const { dataPoolId, isStaff } = useContext(AppContext);
  const dispatch = useContext(DocumentDispatchContext);
  const theme = useTheme();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: '8px' }}>
      <Tooltip placement="top" title={`Mark`} disableFocusListener disableTouchListener>
        <Link
          to={`/data-pools/${dataPoolId}/train/${trainingSet.id}/mark/${document.id}`}
          style={{ textDecoration: 'none', color: theme.palette.custom.lightGreen }}
          data-cy={`icon-mark-document-${document.label}`}
        >
          <DrawIcon fontSize="small" />
        </Link>
      </Tooltip>
      <Tooltip placement="top" title={`View Document`} disableFocusListener disableTouchListener>
        <Box component="span">
          <SvgEyeIcon
            className={TableStyles.eyeIcon}
            data-cy={`icon-view-document-${document.label}`}
            onClick={(event) => {
              event.stopPropagation();
              dispatch({
                type: 'TOGGLE_VIEW_DOCUMENT_MODAL',
                pages: document.pages,
                id: document.id,
              });
            }}
          />
        </Box>
      </Tooltip>
      {isStaff ? (
        <DownloadDocument
          documentId={document.id}
          documentContentType={document.content_type}
          documentLabel={document.label}
          documentFileExtension={document.file_extension}
          iconType="file"
        />
      ) : null}
      <TrainingSetDeleteDocument
        documentLabel={document.label}
        documentId={document.id}
        trainingSet={trainingSet}
      />
    </div>
  );
};

export default TrainingSetDocumentActions;
